export default __webpack_public_path__ + "static/media/logo-header.10329eb2.png";